import { Tag } from "antd";
import React from "react";
import GroupListScreen from "../GroupListScreen";
import useGroupBranchOptions from "../useGroupBranchOptions";
import { fetchGroupAdmissions } from "../../../services/groupConsole.service";

const nameColumn = {
  title: "Name",
  key: "name",
  render: (r) => [r.first_name, r.last_name].filter(Boolean).join(" ") || "—",
};

const GroupAdmissions = () => {
  const branches = useGroupBranchOptions();
  return (
    <GroupListScreen
      title="Admissions"
      queryKey="group-console-admissions"
      fetchFn={fetchGroupAdmissions}
      searchPlaceholder="Search by name or application number"
      branchOptions={branches.options}
      branchOptionsLoading={branches.isLoading}
      columns={[
        nameColumn,
        { title: "Application No.", dataIndex: "application_number", align: "center" },
        {
          title: "Status",
          dataIndex: "status",
          align: "center",
          render: (status) => <Tag>{status || "—"}</Tag>,
        },
      ]}
    />
  );
};

export default GroupAdmissions;
